export default __webpack_public_path__ + "4e31a6fcd74488cffa1111d14b436784.jpeg";